import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

export const Positioner = (props: BaseMenu.Positioner.Props) => {
  return (
    <BaseMenu.Positioner
      sideOffset={4}
      {...props}
      className={cn('z-popover', props.className)}
    />
  )
}
